import { useMemo } from "react";

interface TabIndices {
  chatImage: number;
  currentExerciseImage: number;
  upload: number;
  draw: number;
  camera: number;
}

/**
 * Hook to calculate tab indices based on whether images are present
 * Chat image and current exercise image tabs are shown conditionally and take first indices
 */
export const useTabIndices = (hasChatImage: boolean, hasCurrentExerciseImage: boolean): TabIndices => {
  return useMemo(() => {
    let nextIndex = 0;
    const indices = {
      chatImage: -1,
      currentExerciseImage: -1,
      upload: -1,
      draw: -1,
      camera: -1,
    };

    // Assign indices based on what's available
    if (hasChatImage) {
      indices.chatImage = nextIndex++;
    }
    if (hasCurrentExerciseImage) {
      indices.currentExerciseImage = nextIndex++;
    }
    indices.upload = nextIndex++;
    indices.draw = nextIndex++;
    indices.camera = nextIndex++;

    return indices;
  }, [hasChatImage, hasCurrentExerciseImage]);
};
